import { COMMON_I18N_KEYS } from '../../../../../features/home/components/constants/i18n/Commoni18nConstants';

export const COMMON_I18N_EN =  {
  [COMMON_I18N_KEYS.see_more]:          "See More",
  [COMMON_I18N_KEYS.see_less]:          "See Less",
  [COMMON_I18N_KEYS.contact_us]:        "CONTACT US",
  [COMMON_I18N_KEYS.add_topic]:         "ADD TOPIC",
  [COMMON_I18N_KEYS.load_more]:         "LOAD MORE",
  [COMMON_I18N_KEYS.no_articles_title]: "No articles available",
  [COMMON_I18N_KEYS.its_empty_title]:   "It’s Empty"
}


// WEBPACK FOOTER //
// ./src/locales/en/features/home/components/common.i18n.en.js